import { useTranslation } from 'react-i18next';
import { FeatureLifecycleStatus } from '@/models/common/FeatureLifecycleStatus';
import StateChip, { StateTone } from '@/components/ui/StateChip/StateChip';

export const toneOfStatus: Record<FeatureLifecycleStatus, StateTone> = {
  [FeatureLifecycleStatus.NotReleased]: 'grey',
  [FeatureLifecycleStatus.InRollout]: 'amber',
  [FeatureLifecycleStatus.FullyReleased]: 'green',
};

/** «סגור / פתוח לחלק / פתוח לכולם», in the colours every state chip uses. */
const LifecycleStatusChip = ({ status }: { status: FeatureLifecycleStatus }) => {
  const { t } = useTranslation();
  return <StateChip tone={toneOfStatus[status]}>{t(`featureFlags.status.${status}`)}</StateChip>;
};

export default LifecycleStatusChip;
